import { render, staticRenderFns } from "./choiceUp.vue?vue&type=template&id=d8ddaad2&scoped=true&lang=pug"
import script from "./choiceUp.vue?vue&type=script&lang=js"
export * from "./choiceUp.vue?vue&type=script&lang=js"
import style0 from "./choiceUp.vue?vue&type=style&index=0&id=d8ddaad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ddaad2",
  null
  
)

export default component.exports